import { onMounted, onBeforeUnmount, ref, computed, watch } from "vue";
import { useStore } from "vuex";

import { columns, options } from "@/helpers/usersTableHelper.js";

export default function useCourseTable() {
  const store = useStore();

  const tableData = computed(() => store.getters["users/getUsers"]);
  const permissions = computed(() => store.getters["users/getPermissions"]);
  const message = computed(() => store.getters["users/getMessage"]);
  const error = computed(() => store.getters["users/getError"]);

  const showEditModal = ref(false);
  const selectedUser = ref(null);

  const tableOptions = {
    ...options,
  };

  onMounted(async () => {
    document.addEventListener("click", handleClick);
    await store.dispatch("users/fetchUsers");
    await store.dispatch("users/fetchPermissions");
  });
  onBeforeUnmount(() => {
    document.removeEventListener("click", handleClick);
  });

  const handleClick = (event) => {
    if (event.target && event.target.classList.contains("edit-user-btn")) {
      const data = event.target.getAttribute("data");
      const user = JSON.parse(data.replace(/&quot;/g, '"'));
      editUser(user);
    }
  };

  watch(error, (newError) => {
    if (newError) {
      store.dispatch("toastNotification/displayToast", {
        message: newError,
        type: "error",
      });
    }
  });

  watch(message, (newStatus) => {
    if (newStatus) {
      closeEditModal();
      store.dispatch("toastNotification/displayToast", {
        message: newStatus,
        type: "success",
      });
    }
  });

  const editUser = async (user) => {
    await store.dispatch("users/fetchUserPermissions", user.id);
    selectedUser.value = user;
    showEditModal.value = true;
  };

  const closeEditModal = async () => {
    selectedUser.value = null;
    showEditModal.value = false;
    await store.dispatch("users/fetchUsers");
  };

  return {
    columns,
    tableData,
    permissions,
    tableOptions,
    showEditModal,
    selectedUser,
    closeEditModal,
  };
}
